import { Link } from "react-router-dom";
import { ArrowRight, MessageCircle } from "lucide-react";
import { EventBanner } from "../components/site/EventBanner";
import { ArticleCard, CattleCardCompact } from "../components/site/Cards";
import { BACKEND, img, useGet, useSettings, waLink } from "../lib/api";

const Hero = ({ wa, image }) => (
  <section className="mx-auto max-w-7xl px-5 pt-5 lg:px-8" data-testid="hero-section">
    <div className="grid items-center gap-8 overflow-hidden rounded-[2rem] bg-[var(--cream)] p-6 md:grid-cols-2 md:p-10">
      <div className="fade-up">
          <p className="eyebrow">Peternakan Sapi Sembada Satwa</p>
          <h1 className="mt-3 font-display text-3xl font-semibold leading-tight text-[var(--forest-dark)] sm:text-4xl lg:text-5xl" data-testid="hero-headline">
            Sapi Sehat dari Kandang yang Terawat
          </h1>
          <p className="mt-4 max-w-lg text-base text-[var(--ink)]/75">
            Pilih sapi Limousin, Simmental, dan Bali untuk qurban maupun ternak, langsung dari peternakan kami.
          </p>
          <div className="mt-7 flex flex-wrap gap-3">
            <Link to="/katalog" className="btn-forest" data-testid="hero-cta-katalog">Lihat Katalog Sapi <ArrowRight className="h-4 w-4" /></Link>
            <a href={waLink(wa, "Halo Sembada Satwa, saya ingin bertanya tentang sapi.")} target="_blank" rel="noreferrer" className="btn-gold" data-testid="hero-cta-whatsapp">
              <MessageCircle className="h-4 w-4" /> Chat WhatsApp
            </a>
          </div>
      </div>
      <img src={image ? img(image) : `${BACKEND}/api/uploads/seed1.jpg`} data-testid="hero-image" alt="Kandang sapi Sembada Satwa" className="h-64 w-full rounded-3xl object-cover shadow-xl md:h-[380px]" />
    </div>
  </section>
);

const SectionHead = ({ eyebrow, title, to, testid }) => (
  <div className="mb-10 flex flex-wrap items-end justify-between gap-4">
    <div>
      <p className="eyebrow">{eyebrow}</p>
      <h2 className="mt-2 font-display text-3xl font-semibold text-[var(--forest-dark)] md:text-4xl">{title}</h2>
    </div>
    <Link to={to} className="text-sm font-semibold text-[var(--forest)] hover:underline" data-testid={testid}>Lihat semua →</Link>
  </div>
);

export default function Home() {
  const { data: s } = useSettings();
  const { data: articles } = useGet("articles", "/articles", { limit: 3 });
  const { data: cattle } = useGet("cattle", "/cattle", {});
  return (
    <>
      <EventBanner />
      <Hero wa={s?.whatsapp} image={s?.hero_image_url} />
      <section className="mx-auto max-w-7xl px-5 py-20 lg:px-8" data-testid="home-cattle-preview">
        <SectionHead eyebrow="Katalog" title="Sapi Siap Dipilih" to="/katalog" testid="home-see-all-cattle" />
        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
          {(cattle || []).slice(0, 20).map((c) => <CattleCardCompact key={c.id} c={c} whatsapp={s?.whatsapp} />)}
        </div>
      </section>
      <section className="bg-[var(--cream)] py-20" data-testid="home-articles-preview">
        <div className="mx-auto max-w-7xl px-5 lg:px-8">
          <SectionHead eyebrow="Pojok Edukasi" title="Artikel Terbaru" to="/edukasi" testid="home-see-all-articles" />
          <div className="grid gap-7 md:grid-cols-3">
            {(articles || []).map((a) => <ArticleCard key={a.id} a={a} />)}
          </div>
        </div>
      </section>
    </>
  );
}
